import { Clock, LogIn, LogOut } from "lucide-react";

export interface AttendanceData {
  checkInTime?: string;
  checkOutTime?: string;
  totalHours?: string;
}

const AttendanceStats = ({ 
  checkInTime = "--:--", 
  checkOutTime = "--:--", 
  totalHours = "--:--" 
}: AttendanceData) => {
  const stats = [
    {
      icon: LogIn,
      label: "Check In",
      value: checkInTime,
    },
    {
      icon: LogOut,
      label: "Check Out", 
      value: checkOutTime,
    },
    {
      icon: Clock,
      label: "Total Hrs",
      value: totalHours,
    },
  ];

  return (
    <div className="flex justify-between gap-4 px-6 py-4">
      {stats.map((stat, index) => (
        <div key={index} className="flex flex-col items-center space-y-2">
          <div className="w-12 h-12 rounded-full bg-secondary flex items-center justify-center">
            <stat.icon className="w-5 h-5 text-stats-icon" />
          </div>
          <div className="text-center">
            <div className="text-sm font-medium text-time-display">{stat.value}</div>
            <div className="text-xs text-time-secondary">{stat.label}</div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default AttendanceStats;